import { CommercialSegment } from '../types/commercialSegment'
import api from './axios'

const baseUrl = '/rest/v1/commercial-segments'

export async function getCommercialSegments(): Promise<CommercialSegment[]> {
    const res = await api.get<PagedResult<CommercialSegment>>(baseUrl)
    return res.data.items
}